import { DeviceTable } from './DeviceTable'
export default DeviceTable
